import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { string, boolean, number, any, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isSegmentPrimitiveReference = objectOf({
  id: string,
  name: string,
});

export const isEngagementApiSuppressionListsIdResult = objectOf({
  segment: objectOf({
    id: string,
    app_group_id: string,
    name: string,
    description: anyOf(string, nullOrUndefined),
    status: string,
    enabled: boolean,
    using_v2_filters: boolean,
    filters: objectOf({}),
    is_archived: boolean,
    created_at: number,
    updated_at: number,
    exception_tags: arrayOf(isSegmentPrimitiveReference),
  }),
  segment_filter_types: arrayOf(any),
});
